import axios from "api/axios"
import { formatErrorResponse, formatSuccessResponse } from "api/utils"

import { JobApplicationUsage } from "./types"
import { urls } from "./urls"

export default {
  getJobApplicationUsage: async (): Promise<JobApplicationUsage> => {
    try {
      const res = await axios.get(urls.jobApplication.usage)
      return formatSuccessResponse(res)
    } catch (e) {
      throw formatErrorResponse(e)
    }
  },
}
